"use client";

import { Icons } from "@/components/Icons";
// import { Box } from "@fastlooptech/layout-components";
import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { useResponsive } from "@/client/hooks/useResponsive";
import { Display } from "@/client/foundations/Typography";
import { ModalDirection } from "@/components/Modal/Modal";
import { Box } from "@/layouts/LayoutComponents";
import { renderToString } from "react-dom/server";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import dynamic from "next/dynamic";
import { sendEventToGTM } from "@/helpers/gtm.helper";

// import Modal from "@/components/Modal/Modal";

const Modal = dynamic(() => import("@/components/Modal/Modal"));
const wasModalAlreadyOpened = "wasModalAlreadyOpened";

export default function ModalContainer({ children, id, eventName, title, subTitle, description, successMessage, modalVariant, variant, maxWidth, logo, showLogo=false, modalOntimer }: any) {
  const { isMd } = useResponsive();
  const [open, setOpen] = useState(false);
  const [wasOpened, setWasOpened] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [modalBg, setModalBg] = useState('bg-[#FFFFFF]')
  

  const isInFrame = (typeof window !== "undefined") && window.self !== window.top;

  const width = 163;
	const height = 44;

  const image = {
		width: width,
		height: height,
		src: logo || `https://placehold.co/${width}x${height}`,
	};

  useEffect(() => {
    const handleFormSubmit = (e: Event) => {
      console.log('CONTACT US FORM SUBMITTED', e);
      setSubmitted(true);
    };

    window.addEventListener('ModalFormSubmitted', handleFormSubmit);

    let handleOpenEvent: ((e: Event) => void) | null = null;

    if (eventName) {
      handleOpenEvent = (e: Event) => {
        setOpen(true);
        setWasOpened(true);
        sessionStorage?.setItem(wasModalAlreadyOpened, "ok");
      };

      window.addEventListener(eventName, handleOpenEvent);
    }

    return () => {
      window.removeEventListener('ModalFormSubmitted', handleFormSubmit);
      if (eventName && handleOpenEvent) {
        window.removeEventListener(eventName, handleOpenEvent);
      }
    };
  }, [eventName, wasModalAlreadyOpened]);

  // Open Modal automatically using timer
  useEffect(()=>{
    if(modalOntimer >= 1) {
      const defaultModalSession = sessionStorage?.getItem(wasModalAlreadyOpened);
      const timeout = setTimeout(()=>{
        if( !defaultModalSession && !wasOpened && !isInFrame ){
          setOpen(true);
          sessionStorage?.setItem(wasModalAlreadyOpened, "ok");
        }
      }, modalOntimer*1000)
      return () => clearTimeout(timeout); //clean up on unmount or value change
    }

  }, [modalOntimer, wasOpened])

  useEffect(() => {
    setModalBg(variant === "default" ? 'bg-[#FFFFFF]' : variant)
  }, [variant])

  // Open modal using query param. Example:- ?modal=modalId 
  useEffect(()=>{
    if(!open && id === location.search.replace("?modal=","")){
      setOpen(true);
      setWasOpened(true);
      sessionStorage?.setItem(wasModalAlreadyOpened, "ok");
    }
  },[])

  const handleClose = () => {
    sendEventToGTM({
      event: "Modal Closed", 
      component: "Modal", 
      componentId: id || "", 
      modalTitle: title || "",
      modalVariant: modalVariant || "",
      pagePath: window.location.pathname, 
      eventName: eventName || "",
    })
    setOpen(false)
  }

  return (
    <>
      {/* <pre>{JSON.stringify(variant, null, 2)}</pre> */}
      {/* {isInFrame && (<div className="max-w-[800px]"> */}
        {isInFrame && (<div className="max-w-none w-full">
        {children}
      </div>)}
      <Box hAlignContent="center" id={id} className="modal-container">
        <Modal
          direction={ModalDirection.BottomUp}
          title={title}
          subTitle={subTitle}
          description={description && renderToString(documentToReactComponents(description))}
          onClose={() => handleClose()}
          open={open}
          variant={modalBg}
          closeButton={
            <Icons.Close id="close-icon" size="m" fill="var(--bp-colors-modal-close-icon)" />       
            // modalVariant === "futures" ? (<div className="rounded-full bg-base-white p-1"><Icons.Close id="close-icon" size="s" /></div>) : <Icons.Close id="close-icon" size="m" />
          }
          maxWidth={maxWidth || "80vw"}
          modalVariant={modalVariant}
          image={image}
          showLogo={showLogo}
        //footerElement={}
        >
          {submitted ? (
            <Box column hAlignContent="center" vAlignContent="center">
              <Display size="m">{successMessage}</Display>
            </Box>
          ) : (
            <Box className={classNames(
              isMd ? "max-h-[500px]" : "",
              "w-full"
            )}>
              {children}
            </Box>
          )}
        </Modal>
      </Box>
    </>
  );
}